module.exports = __webpack_public_path__ + "static/media/test4.33bb97f9.jpeg";